import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import { FormattedMessage as T, useIntl } from "react-intl";
import persistanceStore from "stores/persistanceStore";
import { standardDateFormat } from "utils/dateUtils";
import { isValid } from "date-fns";
import {
  DatePicker,
  DatePickerSlotsComponentsProps,
} from "@mui/x-date-pickers";

const datePickerSlotProps: DatePickerSlotsComponentsProps<Date> = {
  textField: { fullWidth: true, variant: "outlined" },
  actionBar: {
    actions: ["clear", "cancel"],
  },
};

export default function ResourceLibraryItemFilter() {
  const { formatMessage: t } = useIntl();

  const searchTerm = persistanceStore.useState(
    (s) => s.resourceLibraryItemFilterSearchTerm
  );
  const dateFrom = persistanceStore.useState(
    (s) => s.resourceLibraryItemFilterDateFrom
  );
  const dateTo = persistanceStore.useState(
    (s) => s.resourceLibraryItemFilterDateTo
  );

  const setTerm = (term: string) => {
    persistanceStore.update((s) => {
      s.resourceLibraryItemFilterSearchTerm = term;
    });
  };

  const setDateFrom = (date: any) => {
    persistanceStore.update((s) => {
      s.resourceLibraryItemFilterDateFrom = isValid(date) ? date : null;
    });
  };

  const setDateTo = (date: any) =>
    persistanceStore.update((s) => {
      s.resourceLibraryItemFilterDateTo = isValid(date) ? date : null;
    });

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>
          <T id="filtersLabel" />
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box mb={3} width="100%">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                fullWidth
                value={searchTerm ?? ""}
                placeholder={t({ id: "searchPlaceholder" })}
                onChange={(e) => setTerm(e.target.value)}
                InputProps={{
                  startAdornment: <SearchIcon sx={{ mr: 1 }} />,
                  endAdornment: (
                    <IconButton onClick={() => setTerm("")}>
                      <ClearIcon />
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <DatePicker
                label={t({ id: "dateFrom" })}
                value={dateFrom || null}
                format={standardDateFormat}
                slotProps={datePickerSlotProps}
                onChange={setDateFrom}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <DatePicker
                label={t({ id: "dateTo" })}
                value={dateTo || null}
                format={standardDateFormat}
                slotProps={datePickerSlotProps}
                onChange={setDateTo}
              />
            </Grid>
          </Grid>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
